function serializeDomSafely(containerEl) {
    const serializer = new XMLSerializer();
    return Array.from(containerEl.childNodes)
        .map((node) => serializer.serializeToString(node))
        .join("");
}
function unwrapTags(container, tagNames) {
    tagNames.forEach((tag) => {
        container.querySelectorAll(tag).forEach((el) => {
            const parent = el.parentNode;
            if (!parent) {
                return;
            }
            while (el.firstChild) {
                parent.insertBefore(el.firstChild, el);
            }
            parent.removeChild(el);
        });
    });
}
function sanitizeTags(container, tagNames) {
    tagNames.forEach((tag) => {
        container.querySelectorAll(tag).forEach((el) => {
            el.parentNode?.removeChild(el);
        });
    });
}
function replaceTags(container, tagNames, replacementTag = "span") {
    tagNames.forEach((tag) => {
        container.querySelectorAll(tag).forEach((el) => {
            const replacement = document.createElement(replacementTag);
            for (const attr of Array.from(el.attributes)) {
                replacement.setAttribute(attr.name, attr.value);
            }
            while (el.firstChild) {
                replacement.appendChild(el.firstChild);
            }
            el.parentNode?.replaceChild(replacement, el);
        });
    });
}
export function groomRichTextHTML(htmlString, { unwrap = [], sanitize = [], replace = [], replacementTag = "span", trustedPolicyName, } = {}) {
    if (!htmlString) {
        return "";
    }
    let safeHtmlInput = htmlString;
    if (trustedPolicyName && window.trustedTypes) {
        try {
            const policy = window.trustedTypes.createPolicy(trustedPolicyName, {
                createHTML: (input) => input,
            });
            safeHtmlInput = policy.createHTML(htmlString);
        }
        catch (e) {
            console.warn(`Trusted Types policy '${trustedPolicyName}' failed.`, e);
        }
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(safeHtmlInput.toString(), "text/html");
    const body = doc.body;
    unwrapTags(body, unwrap);
    sanitizeTags(body, sanitize);
    replaceTags(body, replace, replacementTag);
    try {
        return body.innerHTML;
    }
    catch (e) {
        console.warn("Reading innerHTML failed. Falling back to serializer.", e);
        return serializeDomSafely(body);
    }
}
